import { Container, Stack, Text, Title } from "@assetwatch/ui";

export function AppNotFound() {
  return (
    <Container size="sm">
      <Stack gap={16}>
        <Title size="lg">Not found</Title>
        <Text tone="subtle">The requested Work page does not exist.</Text>
      </Stack>
    </Container>
  );
}
